import type { Config } from "tailwindcss";

const config: Config = {
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
    screens: {
      header: "1060px",
      desktop: "1024px",
      tablet: "768px",
      mobile: "360px",
      post: "1330px",
    },
    extend: {
      padding: {
        side: "1rem",
      },
      fontSize: {
        12: "0.625rem",
        14: "0.75rem",
        16: "0.875rem",
        18: "1rem",
        20: "1.125rem",
        22: "1.1875rem",
        24: "1.25rem",
        26: "1.375rem",
        28: "1.4375rem",
        30: "1.5rem",
        36: "1.875rem",
        40: "2rem",
        44: "2.125rem",
        48: "2.25rem",
        60: "3rem",
        68: "3.5rem",
        72: "3.75rem",
      },
      colors: {
        primary: "#3960F8",
        gray: "#676767",
        lightgray: "#EFEFEF",
        footer: "#F9FAFB",
      },
      fontFamily: {
        pretendard: "var(--font-pretendard)",
      },
      borderWidth: {
        "1.5": "1.5px",
      },
      boxShadow: {
        "price-card": "0px 0px 20px 0px #00000026",
      },
      keyframes: {
        shake: {
          "0%, 100%": { transform: "rotate(0deg)" },
          "25%": { transform: "rotate(-1deg)" },
          "75%": { transform: "rotate(1deg)" },
        },
        fadeInUp: {
          "0%": { opacity: "0", transform: "translateY(10px)" },
          "100%": { opacity: "1", transform: "translateY(0)" },
        },
        scaleUp: {
          "0%": { transform: "scale(0.8)" },
          "100%": { transform: "scale(1)" },
        },
        check: {
          "0%": { strokeDashoffset: "100", strokeDasharray: "100" },
          "100%": { strokeDashoffset: "0" },
        },
        modalFadeIn: {
          "0%": { opacity: "0" },
          "100%": { opacity: "1" },
        },
        modalSlideUp: {
          "0%": { opacity: "0", transform: "translateY(16px) scale(0.97)" },
          "100%": { opacity: "1", transform: "translateY(0) scale(1)" },
        },
      },
      animation: {
        shake: "shake 0.5s ease-in-out",
        fadeInUp: "fadeInUp 0.5s ease-in-out",
        scaleUp: "scaleUp 0.5s ease-in-out",
        check: "check 2s ease forwards",
        modalFadeIn: "modalFadeIn 0.3s ease",
        modalSlideUp: "modalSlideUp 0.35s ease",
      },
    },
  },
  plugins: [],
};
export default config;
